export default __webpack_public_path__ + "static/media/application_icon.e312a0bc.svg";